import { createSelector } from "@reduxjs/toolkit";
import { selectSelf } from "../../storeConfig";

export const NotificationModalSelector = createSelector(
  selectSelf,
  ({ NotificationModal }) => NotificationModal.modalContent
);
